import { render, staticRenderFns } from "./FormManifestRateComponent.vue?vue&type=template&id=83405700&"
import script from "./FormManifestRateComponent.vue?vue&type=script&lang=js&"
export * from "./FormManifestRateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports